import React, { useCallback, useEffect, useRef } from "react";

import Form, { ButtonItem, EmptyItem, SimpleItem } from "devextreme-react/form";
import { Label } from "devextreme-react/tree-list";
//--
import { run } from "effection";
//--
import isEqual from "react-fast-compare";
import { useTranslation } from "react-i18next";

import { useReverseRoute } from "@app/contexts";
import {
  updateWhoami,
  useAppDispatch,
  useAppSelector,
  whoamiSelect,
} from "@app/state";

import "./whoami.scss";

import type { Operation } from "effection";
import type { IWhoAmI } from "@app/types";
import type { ButtonType } from "devextreme/common";

export const DefineWhoAmI = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const formRef = useRef<any>(null);
  const dataRef = useRef<any>(null);
  const { routeInit } = useReverseRoute("whoami");
  const theData = useAppSelector(whoamiSelect);

  //eslint-disable-next-line require-yield
  function* eStartUpdate(): Operation<string> {
    if (formRef?.current) {
      formRef.current.instance().beginUpdate();
    }
    return "started";
  }
  //eslint-disable-next-line require-yield
  function* eEndUpdate(): Operation<string> {
    if (formRef?.current) {
      formRef.current.instance().endUpdate();
    }
    return "ended";
  }
  const eUpdateRecord = ({
    key,
    values,
  }: {
    key: { ALGID: number };
    values: IWhoAmI;
  }) =>
    function* (): Operation<boolean> {
      yield* eStartUpdate();
      // console.log("eUpdateRecord", key, values);
      yield* eEndUpdate();
      return true;
    };

  const eSaveRecord = () => {
    return function* (): Operation<boolean> {
      yield* eStartUpdate();
      dispatch(updateWhoami(dataRef.current));
      yield* eEndUpdate();
      return true;
    };
  };

  useEffect(() => {
    const eq = isEqual(dataRef.current, theData);
    if (!eq) {
      dataRef.current = theData;
      run(eUpdateRecord({ key: { ALGID: theData.ALGID }, values: theData }));
    }
    return () => {
      dataRef.current = null;
    };
  }, [JSON.stringify(theData)]);

  const formFieldDataChanged = useCallback((e: any) => {
    const { dataField, value } = e;
    const eq = isEqual(dataRef.current[dataField], value);
    if (!eq) {
      dataRef.current[dataField] = value;
      run(
        eUpdateRecord({
          key: { ALGID: theData.ALGID },
          values: dataRef.current,
        })
      );
    }
  }, []);

  const buttonOptions = {
    text: t("Save"),
    type: "default" as ButtonType,
    icon: "save",
    useSubmitBehavior: false,
    onClick: () => {
      run(eSaveRecord());
    },
  };
  const RoleItem = () => {
    return <div>{t(dataRef.current?.roles?.[0])}</div>;
  };
  const EmailItem = () => {
    return <div>{dataRef.current?.email}</div>;
  };
  const VerifiedItem = () => {
    return <div>{dataRef.current?.email_verified ? "DA" : "NU"} </div>;
  };
  return (
    <div ref={routeInit}>
      <form>
        <Form
          elementAttr={{ cssClass: "whoami-form" }}
          ref={formRef}
          formData={theData}
          onFieldDataChanged={formFieldDataChanged}
          colCount={2}
          // visible={mode === 'FULL'}
          // onContentReady={formContentReady}
        >
          {/* <SimpleItem dataField="ALGID" editorType="dxNumberBox"/> */}
          {/* <SimpleItem dataField="PERSEED" editorType="dxTextBox" /> */}
          {/* <SimpleItem dataField="IS_ACTIVE" editorType="dxCheckBox" /> */}
          {/* <SimpleItem dataField="ACCESS_LEVEL" editorType="dxNumberBox" /> */}

          <SimpleItem dataField="email" render={EmailItem} colSpan={2}>
            <Label text="Cont" />
          </SimpleItem>

          <SimpleItem dataField="FIRST_NAME" editorType="dxTextBox">
            <Label text={t("Prenume")} />
          </SimpleItem>
          <SimpleItem dataField="LAST_NAME" editorType="dxTextBox">
            <Label text={t("Nume")} />
          </SimpleItem>
          <SimpleItem render={RoleItem}>
            <Label text="Rol" />
          </SimpleItem>
          <SimpleItem dataField="email_verified" render={VerifiedItem}>
            <Label text="Email verificat" />
          </SimpleItem>
          <EmptyItem />
          <ButtonItem buttonOptions={buttonOptions} />
        </Form>
      </form>
    </div>
  );
};

/* 
 export type TRoles = "REGUEST" | "JGADMIN" | "JGUSER" | "SWS" | "@SWCRE"never;
 t('REGUEST');
 t('JGADMIN');
 t('JGUSER');
 t('SWS');
 */
